import { isEmpty as _isEmpty } from "lodash";
import * as React from "react";
import IDietGuidelineResponse from "../../models/maverick/IDietGuidelineResponse";
import { AppPlaceholders } from "../../utils/AppConstants";
import TextInput from "../TextInput";


/**
 * Created by aditya on 28/06/18.
 */

export interface DietThemeItemEditorProps {
    item: string;
    onDataChange: (update: any) => any,
    fetchStaticLifeStyleData?: (input: string) => Promise<any>,
    fetchStaticGuidelines: (input: string, category: string) => Promise<IDietGuidelineResponse[]>
}

class DietThemeItemEditor extends React.Component<DietThemeItemEditorProps> {
    constructor(props: DietThemeItemEditorProps) {
        super(props)
    }

    render() {
        let dietThemeName = !_isEmpty(this.props.item) ? this.props.item : "";
        return (
            <div className="diet-theme-item-editor" >
                <div className="diet-theme-item-editor-name">
                    <TextInput name={"diet-theme-name"} value={dietThemeName} placeholder={AppPlaceholders.DIET_PLAN_EDITVIEW_THEME} onChange={(evt) => this.props.onDataChange(evt.target.value)} />
                    {/*<TypeAhead widgetName={"DietThemeItem"} name={"diet-theme-name"} value={dietThemeName} placeholder={AppPlaceholders.DIET_PLAN_EDITVIEW_THEME} onTypeAheadChange={this.onTypeAheadChange} onTypeAheadSelect={this.onTypeAheadSelect}/>*/}
                </div>
            </div>
        )
    }
}

export default DietThemeItemEditor;
